import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CsrfService {
  private readonly keyToken = 'csrf';

  getToken(): string {
    return localStorage.getItem(this.keyToken);
  }

  setToken(token: string): void {
    localStorage.setItem(this.keyToken, token);
    return;
  }

  removeToken(): void {
    localStorage.removeItem(this.keyToken);
    return;
  }
}
